import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { ADS, slotFor, type AdPlacement } from './config';
import { loadAdSense } from './loader';

/**
 * A clearly labelled ad unit with reserved space (no layout jump when it fills).
 * Renders nothing at all while ads aren't configured: never an empty placeholder.
 */
export function AdSlot({ placement, className = '' }: { placement: AdPlacement; className?: string }) {
  const slot = slotFor(placement);
  const { pathname } = useLocation();
  if (!slot) return null;
  return <AdUnit key={`${pathname}-${placement}`} slot={slot} placement={placement} className={className} />;
}

function AdUnit({ slot, placement, className }: { slot: string; placement: AdPlacement; className: string }) {
  const ref = useRef<HTMLModElement>(null);
  useEffect(() => {
    loadAdSense();
    try {
      if (ref.current && !ref.current.dataset.adsbygoogleStatus) (window.adsbygoogle = window.adsbygoogle || ([] as never)).push({});
    } catch {
      /* ad blocked or not ready: the slot just stays empty */
    }
  }, []);
  return (
    <aside className={`ad ad--${placement} ${className}`} aria-label="Advertisement">
      <span className="ad__label">Advertisement</span>
      <ins
        ref={ref}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={ADS.client}
        data-ad-slot={slot}
        data-ad-format={placement === 'sidebar' ? 'rectangle' : 'auto'}
        data-full-width-responsive={placement === 'sidebar' ? 'false' : 'true'}
        data-tag-for-age-treatment={ADS.childDirected ? '1' : undefined}
      />
    </aside>
  );
}
